import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';

const API = API_URL.replace(/\/$/, '');

export default function AdminFlags() {
  const [flags, setFlags] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);
  const [openList, setOpenList] = useState(true);
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  async function loadFlags() {
    try {
      setLoading(true); setErr(null);
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const f = await axios.get(`${API}/admin/flags`, { headers });
      setFlags(f.data || []);
    } catch (e: any) {
      setErr(e?.response?.data?.message || e?.message || 'Failed to load flags');
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { loadFlags(); }, []);

  return (
    <div className="p-6 space-y-6 themed-page">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-heading">Admin — Flags</h2>
        <button className="btn text-xs" onClick={loadFlags}>Refresh</button>
      </div>
      {err && <div className="text-red-500 text-sm">{err}</div>}
      {loading ? (
        <div className="text-theme-secondary">Loading…</div>
      ) : (
        <section className="p-4 rounded-xl themed-card">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold text-heading">Recent Flags</h3>
            <button className="btn text-xs" onClick={() => setOpenList((v) => !v)}>{openList ? 'Hide' : 'Show'}</button>
          </div>
          {openList && (
            <ul className="text-xs mt-2 space-y-2 max-h-80 overflow-y-auto pr-1">
              {flags.map((f) => (
                <li key={f.id} className="rounded-lg themed-card p-2 hover:shadow-sm transition-shadow">
                  <div className="flex items-center justify-between">
                    <span className="px-2 py-0.5 rounded-full text-[11px] bg-amber-500/10 text-amber-400">{f.type}</span>
                    <span className="text-theme-secondary">{new Date(f.createdAt).toLocaleString()}</span>
                  </div>
                  <div className="mt-1">{f.contentSnippet}</div>
                  <div className="text-[11px] text-theme-secondary mt-1">User: {f.user?.username || ''} • Source: {f.sourceId}</div>
                </li>
              ))}
            </ul>
          )}
        </section>
      )}
    </div>
  );
}
